// F = Facture; A = Avoir
enum BILL_TYPE {
  BILL = 'F',
  CREDIT = 'A',
  BRM = 'B',
}

export default BILL_TYPE
